import { RatioValue } from './consts';

export const convertRatioParamToRatioValue = (
  ratioParam: string | number,
): RatioValue => {
  if (typeof ratioParam === 'string') {
    const [numerator, denominator] = ratioParam.split(':').map(Number);
    return numerator / denominator;
  }
  return ratioParam as RatioValue;
};
